import * as React from "react";
import { createIcon } from "@chakra-ui/react";

const HeartRectangleOutlined = createIcon({
  path: (
    <path
      d="M3.32292 19C1.13466 19 0 17.8698 0 15.701V3.29904C0 1.12004 1.13466 0 3.32292 0H20.6771C22.8653 0 24 1.13023 24 3.29904V15.701C24 17.8698 22.8653 19 20.6771 19H3.32292ZM3.44449 17.0043H20.5555C21.4875 17.0043 22.0144 16.5155 22.0144 15.5279V3.47213C22.0144 2.48446 21.4875 1.98553 20.5555 1.98553H3.44449C2.50232 1.98553 1.98565 2.48446 1.98565 3.47213V15.5279C1.98565 16.5155 2.50232 17.0043 3.44449 17.0043ZM9.61418 5.07074C10.7083 5.07074 11.5289 5.70204 12.0152 6.57771C12.4913 5.70204 13.3322 5.07074 14.4061 5.07074C16.0777 5.07074 17.3238 6.3537 17.3238 8.15595C17.3238 10.9255 14.325 13.3183 12.542 14.4791C12.3799 14.5809 12.1672 14.7133 12.0253 14.7133C11.8936 14.7133 11.6606 14.5809 11.4884 14.4791C9.6851 13.3387 6.70663 10.9255 6.70663 8.15595C6.70663 6.3537 7.94259 5.07074 9.61418 5.07074Z"
      fill="currentColor"
    />
  ),
  viewBox: "0 0 24 19",
});

export { HeartRectangleOutlined };
